import { type Component, createMemo } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import type { ContainerPropsType } from '~/types/Container'

const Container: Component<ContainerPropsType> = props => {
  const containerClasses = createMemo(() => twMerge(`mx-auto w-full max-w-7xl px-4 md:px-8`, props.class))
  return (
    <div {...props} class={containerClasses()}>
      {props.children}
    </div>
  )
}

export default Container
